import {
  NoResults,
  Pagination,
  RefinementListPanel,
  SearchBox,
  SortBy,
  Stats,
  ToggleRefinement,
  WhiteInstantSearchBuilder,
} from '@white-nl/instantsearch-components';
import { Hit } from '../../components/artworks/results';

import './artworks-catalog.css';

const settings = document.getElementById('catalog-artworks')?.dataset || null;
const whiteInstantSearchCatalog = new WhiteInstantSearchBuilder();
if (settings) {
  window.initMobileNavFilters();

  const apiUrl = window.Craft.getSiteUrl('api/react/artworks');

  fetch(apiUrl, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  }).then((res) => res.json())
    .then((data) => {
      const {
        translates,
        bookmarks,
        priceBracketOrder,
        priceBracketMapping,
      } = data;

      const {
        artworks,
        pagination,
      } = translates;

      const currentRefinementsExclude = [];

      whiteInstantSearchCatalog
        .withSearchkit(
          settings.indexName,
          settings.publicUrl || '',
          settings.jwt || '',
          settings.refreshUrl || '',
        )
        .withWhiteInstantSearchRouting({
          baseUrl: settings.baseUrl,
          addTrailingSlashesToUrls: window.Craft.trailingSlashes,
          writeDelay: 0,
        })
        .addAdditionalData({
          artworks,
          bookmarks,
        })
        .addSortByComponent(
          [
            {
              settings: {
                items: [
                  {
                    label: window.Craft.t(artworks, 'Best Match', {}),
                    value: settings.indexName,
                  },
                  {
                    label: window.Craft.t(artworks, 'Title A-Z', {}),
                    value: `${settings.indexName}artworks_by_title_asc`,
                  },
                  {
                    label: window.Craft.t(artworks, 'Title Z-A', {}),
                    value: `${settings.indexName}artworks_by_title_desc`,
                  },
                  {
                    label: window.Craft.t(artworks, 'Artist A-Z', {}),
                    value: `${settings.indexName}artworks_by_artist_asc`,
                  },
                  {
                    label: window.Craft.t(artworks, 'Artist Z-A', {}),
                    value: `${settings.indexName}artworks_by_artist_desc`,
                  },
                  {
                    label: window.Craft.t(artworks, 'Gallery A-Z', {}),
                    value: `${settings.indexName}artworks_by_gallery_asc`,
                  },
                  {
                    label: window.Craft.t(artworks, 'Gallery Z-A', {}),
                    value: `${settings.indexName}artworks_by_gallery_desc`,
                  },
                ],
              },
              component: SortBy,
            },
          ],
        )
        .addHitComponent(
          [
            {
              settings: {
                noResults: {
                  translations: {
                    noResults: window.Craft.t(artworks, 'Sorry, we can\'t find any content!', {}),
                    refinements: window.Craft.t(artworks, 'Try to choose another category or filter.', {}),
                    query: window.Craft.t(artworks, 'Please try another query.', {}),
                  },
                },
              },
              component: Hit,
              noResultsComponent: NoResults,
            },
          ],
          '#white-instant-search-hits',
        )
        .setHitsPerPage(24)
        .addPaginationComponent([
          {
            settings: {
              classNames: {
                noRefinementRoot: 'hidden',
                list: 'pagination-list',
                pageItem: 'pagination-item',
                link: 'pagination-link',
                previousPageItem: 'pagination-link pagination-link-prev',
                selectedItem: 'active',
                disabledItem: 'disabled',
                nextPageItem: 'pagination-link pagination-link-next',
              },
              translations: {
                previousPageItemText: window.Craft.t(pagination, 'Previous', {}),
                nextPageItemText: window.Craft.t(pagination, 'Next', {}),
              },
              showFirst: false,
              showLast: false,
            },
            component: Pagination,
          }])
        .setScrolling({
          includeAttributes: ['page'],
        });

      if (settings.fair) {
        whiteInstantSearchCatalog.whereQuery(`fair="${settings.fair}"`);
        currentRefinementsExclude.push('fair');
      }

      if (settings.showFilters ?? true) {
        whiteInstantSearchCatalog.addToggleRefinement(
          [
            {
              settings: {
                attribute: 'id',
                on: bookmarks,
                off: [],
                label: window.Craft.t(artworks, 'Bookmarks', {}),
                classNames: {
                  root: 'bookmarks-check',
                  label: 'bookmarks-label',
                },
              },
              component: ToggleRefinement,
            },
          ],
          '#bookmark-toggle',
        );
        whiteInstantSearchCatalog
          .addStatsComponent(
            [
              {
                settings: {
                  translations: {
                    resultsFound: '',
                    resultFound: '',
                  },
                },
                component: Stats,
              },
            ],
            '.hits-count',
          )
          .addStatsComponent(
            [
              {
                settings: {
                  translations: {
                    resultsFound: window.Craft.t(artworks, 'artworks', {}),
                    resultFound: window.Craft.t(artworks, 'artwork', {}),
                  },
                },
                component: Stats,
              },
            ],
            '.hits-count-full',
          )
          .addCurrentRefinementsComponent(
            [
              {
                settings: {
                  excludedAttributes: currentRefinementsExclude,
                },
                component: ({ currentRefinements }) => {
                  const { items } = currentRefinements;
                  return items.length > 0 ? items.length : '';
                },
              },
            ],
            '.counter-filters',
          )
          .addSearchingComponent(
            [
              {
                settings: {
                  placeholder: window.Craft.t(artworks, 'Search', {}),
                },
                component: SearchBox,
              },
            ],
            '.white-instant-search-search-box',
          );
        if (!settings.fair) {
          whiteInstantSearchCatalog
            .addRefinementList(
              [
                {
                  settings: {
                    attribute: 'fair',
                    sortBy: ['name:asc'],
                    limit: 999,
                    searchable: false,
                    showMore: false,
                    panelSettings: {
                      collapsiblePanelSettings: {
                        defaultExpanded: true,
                        canCollapse: true,
                      },
                      header: window.Craft.t(artworks, 'Fair', {}),
                      hideIfEmpty: true,
                    },
                  },
                  component: RefinementListPanel,
                },
              ],
            );
        }
        whiteInstantSearchCatalog
          .addRefinementList(
            [
              {
                settings: {
                  attribute: 'category',
                  sortBy: ['name:asc'],
                  limit: 999,
                  searchable: false,
                  showMore: false,
                  panelSettings: {
                    collapsiblePanelSettings: {
                      defaultExpanded: true,
                      canCollapse: true,
                    },
                    header: window.Craft.t(artworks, 'Category', {}),
                    hideIfEmpty: true,
                  },
                },
                component: RefinementListPanel,
              },
            ],
          )
          .addRefinementList(
            [
              {
                settings: {
                  attribute: 'collection',
                  sortBy: ['name:asc'],
                  limit: 999,
                  searchable: false,
                  showMore: false,
                  panelSettings: {
                    collapsiblePanelSettings: {
                      defaultExpanded: true,
                      canCollapse: true,
                    },
                    header: window.Craft.t(artworks, 'Collection', {}),
                    hideIfEmpty: true,
                  },
                },
                component: RefinementListPanel,
              },
            ],
          )
          .addRefinementList(
            [
              {
                settings: {
                  attribute: 'priceBracket',
                  transformItems: (items) => items.map((item) => ({
                    ...item,
                    label: priceBracketMapping[item.label]
                      ?? priceBracketMapping.Other
                      ?? item.label,
                  })),
                  sortBy: (a, b) => {
                    const positionA = priceBracketOrder[a.escapedValue] || -1;
                    const positionB = priceBracketOrder[b.escapedValue] || -1;

                    if (positionA > positionB) {
                      return 1;
                    }
                    if (positionA < positionB) {
                      return -1;
                    }

                    return 0;
                  },
                  limit: 999,
                  searchable: false,
                  showMore: false,
                  panelSettings: {
                    collapsiblePanelSettings: {
                      defaultExpanded: true,
                      canCollapse: true,
                    },
                    header: window.Craft.t(artworks, 'Price Bracket', {}),
                    hideIfEmpty: true,
                  },
                },
                component: RefinementListPanel,
              },
            ],
          )
          .addRefinementList(
            [
              {
                settings: {
                  attribute: 'period',
                  sortBy: ['escapedValue:desc'],
                  limit: 999,
                  searchable: false,
                  showMore: false,
                  panelSettings: {
                    collapsiblePanelSettings: {
                      defaultExpanded: true,
                      canCollapse: true,
                    },
                    header: window.Craft.t(artworks, 'Period', {}),
                    hideIfEmpty: true,
                  },
                },
                component: RefinementListPanel,
              },
            ],
          );
      }

      whiteInstantSearchCatalog
        .afterRender(() => {
          window.jQuery('.js-flexmasonry-filter-grid').each((i, grid) => {
            window.jQuery(grid).imagesLoaded(() => {
              window.jQuery('.flexmasonry-break').remove();
              setTimeout(() => {
                window.initFlexMasonry();
                window.initGSAP();
              }, 200);
            });
          });
        })
        .build()
        .show();
    });
}
